import { Spin, Tabs } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import PPPageHeader from '../../../components/pageHeader/PPPageHeader';
import Detail from './Detail';
import Facts from './Fact';
import Notes from './Notes';

const ALL_TABS = [
  { key: 'detail', label: 'Захиалгын мэдээлэл' },
  { key: 'fact', label: 'Баримт' },
  { key: 'note', label: 'Тэмдэглэл' },
];

const OrderReturnList = () => {
  const history = useHistory();
  const location = useLocation();
  const result = location.state?.result ?? {};
  const { orderId } = useParams();

  const initialTab = new URLSearchParams(location.search).get('tab') || 'detail';
  const getValidKey = (key) => (ALL_TABS.find((item) => item.key === key) ? key : ALL_TABS[0].key);

  const [currentKey, setCurrentKey] = useState(() => getValidKey(initialTab));
  const [detail, setDetail] = useState({});
  const [detailLoading, setDetailLoading] = useState(false);

  useEffect(() => {
    fetchOrderDetail(orderId);
    //eslint-disable-next-line
  }, [orderId]);

  const fetchOrderDetail = async (id) => {
    setDetailLoading(true);
    try {
      const { data } = await axios.get(`/api/v1/request/${id}?type=return`);
      data.statusCode === 200 ? setDetail(data.result) : setDetail({});
    } catch (error) {
      setDetail({});
      console.error('fetchOrderDetail: ', error);
    } finally {
      setDetailLoading(false);
    }
  };

  const routes = [
    {
      to: {
        pathname: '/merchant/order/return',
        search: location.state?.search,
      },
      breadcrumbName: 'Буцаалтын захиалга',
    },
    {
      path: 'first',
      breadcrumbName: 'Захиалгын дэлгэрэнгүй',
    },
  ];

  const onChange = (key) => {
    setCurrentKey(key);
    history.replace({
      pathname: `/merchant/order/returns/${orderId}`,
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <div>
      <PPPageHeader
        title="Захиалгын дэлгэрэнгүй"
        breadcrumb={{
          routes,
        }}
        onBack={() =>
          history.push({
            pathname: '/merchant/order/return',
            search: location.state?.search,
          })
        }
      />
      <Tabs
        activeKey={currentKey}
        onChange={onChange}
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: '0', padding: '0 12px' }}
      />
      <Spin spinning={detailLoading}>
        {currentKey === 'detail' && (
          <Detail detail={detail} meta={result?.meta} reasonEnum={result?.returnReasonEnum} />
        )}
        {currentKey === 'fact' && <Facts facts={detail} getDetailData={fetchOrderDetail} />}
        {currentKey === 'note' && (
          <Notes notes={detail} getDetailData={() => fetchOrderDetail(orderId)} />
        )}
      </Spin>
    </div>
  );
};

export default OrderReturnList;
